"use strict";
function contactAsesorPage() {
    $('form, input, select').attr('autocomplete', 'nope');

    $( "input" ).on( "focus", function(){
        $(this).parent().removeClass( "required has-error" );
    });

    $("#send-asesor-button").on("click", function () {
        showLoading();
        
        var contact_name = $("#contact_name").val();
        var name = $("#neighborhood_name").val();
        var contact_phone = $("#contact_phone").val();
        var contact_email = $("#contact_email").val();
        var aprox_number_houses = $("#aprox_number_houses").val();

        // TODO: agregar selects para que el usuario seleccione su estado y ciudad.

        var state_id = 19; // nuevo leon
        var city_id = 997; // monterrey
        
        if(!validations(contact_name, name, contact_phone, contact_email, aprox_number_houses)){
            $.ajax({
                type:"POST", 
                dataType: "json" ,
                url:"https://api.plusvalconnect.com/api/pre_register",
                //url:"http://127.0.0.1:8000/api/pre_register",
                //url: "http://165.227.92.195/api/pre_register",
                data: {
                    contact_name: contact_name,
                    name: name,
                    contact_phone: contact_phone,
                    contact_email: contact_email,
                    aprox_number_houses: aprox_number_houses,
                    state_id: state_id,
                    city_id: city_id,
                    description: "Agregado desde el landingPage"
                }, 
                success:  function (response) {
                    hideLoading();
                    $(':input').val('');
                    response.success ? successMessage() : errorMessage(response.message)
                },
                error:  function (error) {
                    hideLoading();
                    errorMessage(error)
                }
            })
        }else{
            hideLoading();
            errorMessage("Verifique los campos obligatorios")
        }
        
    });

    function validations(contact_name, name, contact_phone, contact_email, aprox_number_houses){
        var hasError = false

        if(contact_name == ""){
            $("#control-name").addClass( "required has-error" );
            hasError = true;
        }

        if(name == ""){
            $("#control-neighborhood-name").addClass( "required has-error" );
            hasError = true;
        }

        if(contact_phone == ""){
            $("#control-contact-phone").addClass( "required has-error" );
            hasError = true;
        }

        if(contact_email == ""){
            $("#control-contact-email").addClass( "required has-error" );
            hasError = true;
        }

        if(aprox_number_houses == ""){
            $("#control-aprox-number-houses").addClass( "required has-error" );
            hasError = true;
        }
        return hasError;
    }

    function showLoading(){
        $("#send-asesor-button").addClass( "is-loading" );
    }

    function hideLoading(){
        $("#send-asesor-button").removeClass( "is-loading" );
    }

    function successMessage(){
        iziToast.show({
            class: "success-toast",
            icon: "sl sl-icon-check",
            title: "Exito!",
            message: "Información enviada correctamente " ,
            titleColor: "#fff",
            messageColor: "#fff",
            iconColor: "#fff",
            backgroundColor: "#00b289",
            progressBarColor: "#444F60",
            position: "topRight",
            transitionIn: "fadeInUp",
            transitionOut: "fadeOutUp",
            close: false,
            zindex: 99999,
            onClosing: function () {
                location.href = 'index.html';
            },
        });
    }

    function errorMessage(message){
        iziToast.show({
            class: "danger-toast",
            icon: "sl sl-icon-close",
            title: "Error",
            message: message,
            titleColor: "#fff",
            messageColor: "#fff",
            iconColor: "#fff",
            backgroundColor: "#FF7273",
            progressBarColor: "#444F60",
            position: "topRight",
            transitionIn: "fadeInDown",
            close: false,
            zindex: 99999,
          });
    }

}

"use strict";
function contactDoubtsPage() {
    $('form, input, select').attr('autocomplete', 'nope');

    $( "input" ).on( "focus", function(){
        $(this).parent().removeClass( "required has-error" );
    });

    $("#send-doubts-button").on("click", function () {
        showLoading();
        
      
        var contact_phone = $("#contact_phone").val();
        var contact_email = $("#contact_email").val();
        var contact_message = $("#contact_message").val();

        if(!validations(contact_phone, contact_email, contact_message)){
            $.ajax({
                type:"POST", 
                dataType: "json" ,
                url:"https://api.plusvalconnect.com/api/add_suggestion",
                //url:"http://127.0.0.1:8000/api/add_suggestion",
                //url: "http://165.227.92.195/api/add_suggestion",
                data: {
                   
                    contact_phone: contact_phone,
                    contact_email: contact_email,
                    contact_message: contact_message
                   
              
                }, 
                success:  function (response) {
                    hideLoading();
                    $(':input').val('');
                    response.success ? successMessage() : errorMessage(response.message)
                },
                error:  function (error) {
                    hideLoading();
                    errorMessage(error)
                }
            })
        }else{
            hideLoading();
            errorMessage("Verifique los campos obligatorios")
        }
        
    });

    function validations(contact_phone, contact_email, contact_message){
        var hasError = false

    

        if(contact_phone == ""){
            $("#control-contact-phone").addClass( "required has-error" );
            hasError = true;
        }

        if(contact_email == ""){
            $("#control-contact-email").addClass( "required has-error" );
            hasError = true;
        }

        if(contact_message == ""){
            $("#control-contact-message").addClass( "required has-error" );
            hasError = true;
        }
        return hasError;
    }

    function showLoading(){
        $("#send-doubts-button").addClass( "is-loading" );
    }

    function hideLoading(){
        $("#send-doubts-button").removeClass( "is-loading" );
    }

    function successMessage(){
        iziToast.show({
            class: "success-toast",
            icon: "sl sl-icon-check",
            title: "Exito!",
            message: "Información enviada correctamente " ,
            titleColor: "#fff",
            messageColor: "#fff",
            iconColor: "#fff",
            backgroundColor: "#00b289",
            progressBarColor: "#444F60",
            position: "topRight",
            transitionIn: "fadeInUp",
            transitionOut: "fadeOutUp",
            close: false,
            zindex: 99999,
            onClosing: function () {
                location.href = 'index.html';
            },
        });
    }

    function errorMessage(message){
        iziToast.show({
            class: "danger-toast",
            icon: "sl sl-icon-close",
            title: "Error",
            message: message,
            titleColor: "#fff",
            messageColor: "#fff",
            iconColor: "#fff",
            backgroundColor: "#FF7273",
            progressBarColor: "#444F60",
            position: "topRight",
            transitionIn: "fadeInDown",
            close: false,
            zindex: 99999,
          });
    }

}

